'use client'

import { getSessionStoragePreviousUrl } from 'links/login/utils/sessionStoragePreviousUrl'
import { create } from 'zustand'

interface PreviousUrlState {
	previousUrl: string
}

export const usePreviousUrlStore = create<PreviousUrlState>()(() => ({
	previousUrl: getSessionStoragePreviousUrl(),
}))
